import { Component, OnInit, OnDestroy }  from '@angular/core';
import { Router, ROUTER_DIRECTIVES, ActivatedRoute } from '@angular/router';
import { TAFBookB2Service } from './taf-book-b2.service';
import { ITAFBookB2 } from './taf-book-b2-list';

import {DataTable} from 'primeng/primeng';
import {Column} from 'primeng/primeng';
import {Header} from 'primeng/primeng';
import {Button} from 'primeng/primeng';


@Component({
    //templateUrl: 'app/system-management/tafbooks/taf-book-b2/taf-book-b2.component.html',
    template: require('./taf-book-b2.component.html'),
    directives: [ROUTER_DIRECTIVES,DataTable,Column, Header],
    
})

export class TAFBookB2Component implements OnInit, OnDestroy{
    pageTitle: string = 'TAF BOOK b2';
    errorMessage: string;
    tafBookB2Arr: ITAFBookB2;
   
    constructor(private route: ActivatedRoute,
                private router: Router,
                private _tafBookB2Service: TAFBookB2Service) {
                    
    }

    ngOnInit(): void{
        this._tafBookB2Service.getTAFBookB2()
         .subscribe(
                tafBookB2Arr => this.tafBookB2Arr = tafBookB2Arr,
                error =>  this.errorMessage = <any>error);
    }

    ngOnDestroy() {
        //alert("onDestroy");
        //this.sub.unsubscribe();
   }
   
}


/** WEBPACK FOOTER **
 ** ./app/system-management/tafbooks/taf-book-b2/taf-book-b2.component.ts
 **/